<template>
  <div>
    <div class="category-top-bar">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="d-inline-flex">
          <a v-if="!isNew()" class="btn btn-danger btn-icon btn btn mar-rt-10 delete"  @click.prevent="handleDelete('delete')" :title="$t('general.delete') + ' ' + $t('catalogCateg.single')">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-icon btn-success btn mar-rt-10 save"  @click.prevent="validate" :title="$t('general.save')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg>
      </div>
    </div>

    <div class="card translations-card">
      <div class="card-content">
        <h5 class="translations-title">{{$t('catalogCateg.name')}} / {{$t('catalogCateg.shortDescription')}}</h5>
        <div class="lang-tabs">
          <a
            class="lang-tab"
            :class="[{ active: currentSubSection === 'l1', errorT: invalidTabs.includes('l1') }]"
            @click.prevent="openSubSection('l1')"
          >{{ language }}</a>
          <a
            v-for="lang in languages"
            :key="'tab-' + lang.id"
            class="lang-tab"
            :class="[{ active: currentSubSection === lang.id + '-' + lang.short, errorT: invalidTabs.includes(lang.id + '-' + lang.short) }]"
            @click.prevent="openSubSection(lang.id + '-' + lang.short)"
          >{{ lang.short }}</a>
        </div>

        <div v-show="currentSubSection === 'l1'">
          <div class="form-group">
            <label>{{$t('catalogCateg.name')}}</label>
            <input type="text"
                  name="name"
                  :placeholder="$t('catalogCateg.name')"
                  v-validate="modelValidations.name"
                  v-model="model.name"
                  class="form-control">
            <small class="text-danger" v-if="errors.has('name')">
              {{ getError('name') }}
            </small>
          </div>
          <div class="form-group">
            <label>{{$t('catalogCateg.shortDescription')}}</label>
            <textarea rows="5"
                  name="description"
                  :placeholder="$t('catalogCateg.shortDescription')"
                  v-model="model.description"
                  class="form-control"></textarea>
          </div>
        </div>

        <template v-for="lang in languages">
          <div
            :key="'box-' + lang.id"
            v-if="model.localized_fields && model.localized_fields[lang.short]"
            v-show="currentSubSection === lang.id + '-' + lang.short"
          >
            <div class="form-group">
              <label>{{$t('catalogCateg.name')}} ({{ lang.short }})</label>
              <input type="text"
                    :placeholder="$t('catalogCateg.name')"
                    v-model="model.localized_fields[lang.short].name"
                    class="form-control">
              <small class="text-danger" v-if="invalidTabs.includes(lang.id + '-' + lang.short) && (!model.localized_fields[lang.short].name || !model.localized_fields[lang.short].name.trim())">
                {{ $t('validations.requiredField') }}
              </small>
            </div>
            <div class="form-group">
              <label>{{$t('catalogCateg.shortDescription')}} ({{ lang.short }})</label>
              <textarea rows="5"
                    :placeholder="$t('catalogCateg.shortDescription')"
                    v-model="model.localized_fields[lang.short].description"
                    class="form-control"></textarea>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="card">
      <div class="section-header">
        <h5 class="section-header__title">{{$t('catalogCateg.topCategory')}}</h5>
      </div>
      <form>
        <div class="card-content">
          <div class="row">
            <div class="col-md-6">

              <div class="form-group">
                <p-checkbox
                  @input="showMethods()"
                  key="forceMethod"
                  v-model="forceMethod"
                  label="forceMethod">
                <span ref="interval" class="pad-to-7" style="margin: 4px;" name="forceMethod">{{$t('catalogCateg.forceMethod')}}</span>
                </p-checkbox>
                <template v-if="forceMethod">
                  <label class="selectMethod" for="methods">
                      {{$t('catalogCateg.selectMethod')}}
                    <el-select
                      v-if="delivery_options_labels.length"
                      key="methods"
                      name="methods"
                      v-model="selected_delivery_options_labels"
                      v-validate="(forceMethod) ? 'required' : ''"
                      multiple
                      filterable
                      default-first-option
                      :placeholder="$t('general.add')">
                      <template v-for="item in delivery_options_labels">
                            <el-option
                              :key="item.key"
                              :label="item.label"
                              :value="item.key">
                            </el-option>
                      </template>
                    </el-select>
                  </label>
                </template>
              </div>

              <div class="form-group">
                <label>{{$t('catalogProd.hideFromPlatforms')}}</label>
                <v-select
                  v-model="selectedPlatforms"
                  multiple
                  :options="platforms"
                  label="name"
                  :placeholder="$t('catalogProd.timeOptionsValues.none')"
                  class="line-heigth-44"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>{{$t('catalogCateg.image')}}</label>
                <el-upload
                  action=""
                  ref="upload"
                  :limit="2"
                  :file-list="model.imagelist"
                  list-type="picture-card"
                  accept=" .jpg, .jpeg, .png"
                  :on-change="handleImgChange"
                  :on-exceed="handleExceed"
                  :on-remove="handleRemove"
                  :auto-upload="false">
                  <img src="/static/img/icons/icon-plus-primary.png">
                  <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
                </el-upload>
              </div>
              <div class="form-group">
                <p-switch v-model="model.active" type="success"></p-switch>
                <label>{{$t('settingLocationGroups.active')}}</label>
              </div>

              <div class="form-group">
                <label>{{$t('marketingCampaigns.visibleInLocations')}}</label>
                <v-select
                  v-model="selectedLocations"
                  multiple
                  :options="locations"
                  label="name"
                  :placeholder="$t('general.all')"
                  class="line-heigth-44"
                />
                <small class="text-muted">{{$t('marketingCampaigns.visibleInLocationsInfo')}}</small>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="card">
      <div class="section-header">
        <h5 class="section-header__title">{{ $t('catalogCateg.schedule') }}</h5>
      </div>
      <div class="card-content">
        <div class="form-group">
          <p-checkbox
            key="overrideSchedule"
            v-model="overrideSchedule"
            label="overrideSchedule"
          >
            <span class="pad-to-7" style="margin: 4px;">{{ $t('catalogCateg.useSchedule') }}</span>
          </p-checkbox>
          <small class="text-muted">{{ $t('catalogCateg.scheduleHelp') }}</small>
        </div>
        <template v-if="overrideSchedule">
          <available-days-schedule
            :available-days="availableDays"
            name-prefix="top-category-schedule-"
          />
        </template>
      </div>
    </div>

    <div class="card reward-card">
      <div class="section-header">
        <img src="/static/img/icons/points-sm.png" class="section-header__icon">
        <h5 class="section-header__title">{{$t('catalogProd.rewardPoints')}}</h5>
      </div>
      <div class="card-content">
        <p class="reward-card__help">
          {{$t('catalogProd.numberOfYouNeedToSpend', { currency: currency })}}
        </p>
        <div class="reward-card__control">
          <span>1&nbsp;{{currency}}&nbsp;=</span>
          <input type="number"
                min="0"
                step="0.1"
                name="monetary_conversion"
                v-model="model.monetary_conversion"
                class="form-control">
          <span>{{$t('catalogProd.points')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import AvailableDaysSchedule from 'src/components/UIComponents/AvailableDaysSchedule.vue'
  import {
    createDefaultAvailableDays,
    normalizeAvailableDays,
    prepareAvailableDaysForSave,
    validateAvailableDays
  } from 'src/components/UIComponents/availableDaysSchedule.js'
  import {Input, Upload, Button, DatePicker, Checkbox, CheckboxGroup, Dialog, Select} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Checkbox)
  Vue.use(CheckboxGroup)
  Vue.use(Dialog)
  Vue.use(Select)

  export default {
    components: {
      [Upload.name]: Upload,
      [Button.name]: Button,
      [Input.name]: Input,
      [Checkbox.name]: Checkbox,
      [CheckboxGroup.name]: CheckboxGroup,
      [Dialog.name]: Dialog,
      [Select.name]: Select,
      PSwitch,
      AvailableDaysSchedule
    },
    computed: {
      ...mapFields(['name', 'description', 'sort_order']),
      currency () {
        const companyData = this.$session.get('selectedCompanyData')
        return companyData ? this.getCurrencySymbol(companyData.currency_iso) : ''
      }
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        currentSubSection: 'l1',
        invalidTabs: [],
        language: '',
        languages: [],
        forceMethod: false,
        delivery_options_labels: false,
        selected_delivery_options_labels: false,
        originalLocationIds: [],
        selectedLocations: [],
        locations: [],
        mainCategories: [],
        selectedPlatforms: [],
        model: {},
        filelist: [],
        filelistToUpload: [],
        generalSuccess: '',
        modelValidations: {
          name: {
            required: true
          }
        },
        loading: true,
        deleteImage: false,
        overrideSchedule: false,
        availableDays: createDefaultAvailableDays(),
        platforms: [
          {id: 1, name: this.$t('addOrder.application')},
          {id: 2, name: 'Website'},
          // {id: 3, name: 'ADMIN'},
          // {id: 4, name: 'KIOSK'},
          // {id: 5, name: 'POS'},
          {id: 6, name: 'QR'}
        ]
      }
    },
    created: function () {
      this.$nextTick(function () {
        this.loading = true
      })

      this.locations = this.$session.get('selectedCompanyData').locations_details.map(location => ({
        id: location.true_id,
        name: location.name
      }))

      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.loadLanguages()
      // get category data
      if (this.route.params.id) {
        var id = this.route.params.id

        this.apiRequest('/topcategory/' + id, 'GET', data, (response) => {
          if (response.status) {
            if (response.data.top_category.image) {
              response.data.top_category.imagelist = [{url: response.data.top_category.image}]
            } else {
              response.data.top_category.imagelist = []
            }
            this.model = response.data.top_category
            this.delivery_options_labels = response.data.delivery_options_labels

            this.forceMethod = response.data.top_category.is_force_method
            this.selected_delivery_options_labels = response.data.top_category.force_methods

            if (this.model.hide_from_platforms && this.model.hide_from_platforms.length) {
              this.selectedPlatforms = this.model.hide_from_platforms.map(t => this.platforms.find(f => f.id === t)) || []
            }

            this.initLocalizedFields()

            if (response.data.locations && response.data.locations.length) {
              this.originalLocationIds = response.data.locations.slice()
              this.selectedLocations = response.data.locations
                .map(id => this.locations.find(loc => loc.id === id.location_id))
                .filter(Boolean)
            } else {
              this.originalLocationIds = []
              this.selectedLocations = []
            }

            this.overrideSchedule = !!response.data.top_category.override_schedule
            if (response.data.schedule_settings && response.data.schedule_settings.available_days) {
              this.availableDays = normalizeAvailableDays(response.data.schedule_settings.available_days)
            } else {
              this.availableDays = createDefaultAvailableDays()
            }

            this.$nextTick(function () { this.loading = false })
          }
        })
      } else {
        this.$nextTick(function () { this.loading = false })
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      loadLanguages () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/company-data', 'GET', data, (response) => {
          if (response.status === true && response.data && response.data.company) {
            this.languages = response.data.company.languages || []
            this.language = response.data.company.language || ''
            this.initLocalizedFields()
          }
        })
      },
      openSubSection (section) {
        this.currentSubSection = section
      },
      initLocalizedFields () {
        if (!this.languages || !this.languages.length) {
          return
        }
        if (!this.model.localized_fields || Array.isArray(this.model.localized_fields)) {
          this.$set(this.model, 'localized_fields', {})
        }
        this.languages.forEach(lang => {
          if (!this.model.localized_fields[lang.short]) {
            this.$set(this.model.localized_fields, lang.short, {
              language_id: lang.id,
              language_short: lang.short,
              name: '',
              description: ''
            })
          } else {
            this.model.localized_fields[lang.short].language_id = lang.id
            this.model.localized_fields[lang.short].language_short = lang.short
          }
        })
      },
      validateLocalizedNames () {
        // Name is required for the base language and for every company language.
        this.invalidTabs = []
        let firstInvalidTab = null

        if (!this.model.name || !String(this.model.name).trim()) {
          this.invalidTabs.push('l1')
          firstInvalidTab = 'l1'
        }

        this.languages.forEach(lang => {
          const lf = this.model.localized_fields ? this.model.localized_fields[lang.short] : null
          const tabKey = lang.id + '-' + lang.short
          if (!lf || !lf.name || !String(lf.name).trim()) {
            if (!this.invalidTabs.includes(tabKey)) {
              this.invalidTabs.push(tabKey)
            }
            if (!firstInvalidTab) {
              firstInvalidTab = tabKey
            }
          }
        })

        if (firstInvalidTab) {
          this.currentSubSection = firstInvalidTab
        }

        return this.invalidTabs.length === 0
      },
      validateSchedule () {
        if (!this.overrideSchedule) {
          return true
        }
        return validateAvailableDays(this.availableDays)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          // this.$emit('on-submit', this.registerForm, isValid)
          const localizedValid = this.validateLocalizedNames()
          if (!localizedValid) {
            isValid = false
          }

          const scheduleValid = this.validateSchedule()
          if (!scheduleValid) {
            isValid = false
          }

          if (isValid) {
            this.errors.clear()
            this.saveCategory()
          } else if (!localizedValid) {
            swal({
              title: '',
              text: 'Numele este obligatoriu pentru toate limbile.',
              type: 'error',
              timer: 3000,
              showConfirmButton: false
            }).catch(() => {})
          } else if (!scheduleValid) {
            swal({
              title: '',
              text: this.$t('settingsOrdering.overrideIntervalMissingHours'),
              type: 'error',
              timer: 3000,
              showConfirmButton: false
            }).catch(() => {})
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            this.errors.add(prop, errors[prop])
          }
        }
      },
      isNew () {
        if (this.route.params.id) {
          return false
        } else {
          return true
        }
      },
      handleRemove (file, fileList) {
        if (fileList.length === 0) {
          this.model.imagelist = []
          this.model.image = null
          this.deleteImage = true
        }
      },
      handleDelete (label) {
        var btnCounter = 3
        var self = this
        swal({
          text: this.$t('catalogCateg.areYouSure', {label: label}),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes') + ' (' + btnCounter + ')'
        })
        .then((result) => {
          if (result) {
            if (this.isNew()) {
              // self.$router.push('/categories')
              self.$bus.$emit('refresh')
              self.$bus.$emit('close-modal')
            } else {
              var id = this.route.params.id
              var data = {
                id: id,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/topcategory/' + id, 'DELETE', data, function (response) {
                // console.warn(response)
                if (response.status === true) {
                  self.trackAdminEvent('ADMIN_TOP_CATEGORY_DELETED', 'top_category', id, {
                    top_category_id: id,
                    name: (self.model && self.model.name) || null
                  })
                  swal(
                    {
                      title: '',
                      text: self.$t('catalogCateg.categDeleted'),
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1500
                    })
                  // self.$router.push('/top-categories')
                  self.$bus.$emit('refresh')
                  self.$bus.$emit('close-modal')
                } else {
                  swal(
                    '',
                    response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'),
                    'error'
                  )
                }
              })
            }
          }
        })
        swal.disableConfirmButton()

        var btnInterval = setInterval(function () {
          btnCounter--

          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = self.$t('general.yes') + ' (' + btnCounter + ')'
          } else {
            swal.getConfirmButton().textContent = self.$t('general.yes')
            clearInterval(btnInterval)
            swal.enableConfirmButton()
          }
        }, 1000)
      },
      handleExceed (files, fileList) {
        swal({
          text: this.$t('general.removePhoto'),
          type: 'warning',
          showConfirmButton: true
        })
      },
      handleImgChange (file, fileList) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('general.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          this.$refs.upload.clearFiles()
          this.model.imagelist = []
        } else {
          if (fileList.length > 1) {
            this.model.imagelist = fileList.slice(1)
          } else {
            this.model.imagelist = fileList
          }
        }
        if (this.model.imagelist && this.model.imagelist[0].status === 'ready') {
          this.getBase64(this.model.imagelist[0].raw).then(
            (base64enc) => {
              this.model.image = base64enc
              this.deleteImage = false
            }
          )
        }
      },
      goBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      },
      buildSavePayload (options = {}) {
        const includeSchedule = options.includeSchedule !== false
        var data = Object.assign({}, this.model)
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')
        data.is_force_method = this.forceMethod
        data.force_methods = this.selected_delivery_options_labels
        data.version = 3
        data.delete_image = this.deleteImage
        data.active = this.model.active || false

        const originalIds = Array.isArray(this.originalLocationIds) ? this.originalLocationIds : []
        const currentIds = Array.isArray(this.selectedLocations)
          ? this.selectedLocations.map(l => l && l.id).filter(Boolean)
          : []

        const locationsPayload = []

        if (Array.isArray(this.selectedLocations) && this.selectedLocations.length) {
          this.selectedLocations.forEach(loc => {
            if (!loc || !loc.id) return
            const isOriginal = originalIds.some(item => {
              const locationId = item && item.location_id !== undefined ? item.location_id : item
              return locationId === loc.id
            })
            locationsPayload.push({
              id: isOriginal ? loc.id : null,
              location_id: loc.id,
              name: loc.name
            })
          })
        }

        if (originalIds.length) {
          originalIds.forEach(item => {
            const id = item && item.location_id !== undefined ? item.location_id : item
            if (!currentIds.includes(id)) {
              locationsPayload.push({
                id: id,
                location_id: id,
                delete: true
              })
            }
          })
        }

        data.locations = locationsPayload

        if (this.selectedPlatforms && this.selectedPlatforms.length) {
          data.hide_from_platforms = this.selectedPlatforms.map(element => element.id)
        } else {
          data.hide_from_platforms = []
        }

        if (data.monetary_conversion === '' || typeof data.monetary_conversion === 'object') {
          data.monetary_conversion = null
        }

        if (includeSchedule) {
          if (this.overrideSchedule) {
            data.override_schedule = true
            data.schedule_settings = {
              available_days: prepareAvailableDaysForSave(this.availableDays)
            }
          } else {
            data.override_schedule = false
            delete data.schedule_settings
          }
        } else {
          delete data.override_schedule
          delete data.schedule_settings
        }

        delete data.parent_category

        return data
      },
      handleSaveSuccess (response) {
        const entityId = (this.route.params && this.route.params.id) ||
          (response && response.data && response.data.id) ||
          null
        this.trackAdminEvent('ADMIN_TOP_CATEGORY_UPDATE', 'top_category', entityId, {
          top_category_id: entityId,
          name: (this.model && this.model.name) || null,
          active: !!(this.model && this.model.active),
          request: this._lastSaveRequest || null,
          response: response
        })
        this.$nextTick(() => { this.loading = false })
        swal(
          {
            title: '',
            text: this.$t('catalogCateg.categAdded'),
            type: 'success',
            showConfirmButton: false,
            timer: 1500
          }
        ).catch(() => {})
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')

        if (response.locations && response.locations.length) {
          this.originalLocationIds = response.locations.slice()
          this.selectedLocations = response.locations
            .map(id => this.locations.find(loc => loc.id === id.location_id))
            .filter(Boolean)
        } else {
          this.originalLocationIds = []
          this.selectedLocations = []
        }
      },
      handleSaveError (response) {
        this.$nextTick(() => { this.loading = false })
        swal(
          {
            title: '',
            text: response.errors && response.errors.error ? response.errors.error : this.$t('validations.wentWrong'),
            type: 'error',
            showConfirmButton: false,
            timer: 5000
          }
        ).catch(() => {})
      },
      saveCategoryWithPut (id, data, onSuccess) {
        this.apiRequest('/topcategory/' + id, 'PUT', data, (response) => {
          if (response.status) {
            this._lastSaveRequest = data
            if (typeof onSuccess === 'function') {
              onSuccess(response)
            } else {
              this.handleSaveSuccess(response)
            }
          } else {
            this.handleSaveError(response)
          }
        })
      },
      saveCategory () {
        this.$nextTick(function () {
          this.loading = true
        })

        const data = this.buildSavePayload()

        if (this.isNew()) {
          const postData = this.buildSavePayload({ includeSchedule: false })
          this.apiRequest('/topcategory/', 'POST', postData, (response) => {
            if (!response.status) {
              this.handleSaveError(response)
              return
            }

            const newId = response.data && response.data.id
            if (this.overrideSchedule && newId) {
              const putData = this.buildSavePayload()
              this.saveCategoryWithPut(newId, putData, (putResponse) => {
                if (putResponse.status) {
                  this.handleSaveSuccess(putResponse)
                } else {
                  this.$nextTick(() => { this.loading = false })
                  swal(
                    {
                      title: '',
                      text: this.$t('catalogCateg.categAdded') + ' ' + this.$t('validations.wentWrong'),
                      type: 'warning',
                      showConfirmButton: true
                    }
                  ).catch(() => {})
                  this.$bus.$emit('refresh')
                  this.$bus.$emit('close-modal')
                }
              })
            } else {
              this.handleSaveSuccess(response)
            }
          })
        } else {
          this.saveCategoryWithPut(this.route.params.id, data)
        }
      },
      showMethods () {
        if (!this.forceMethod) {
          this.selected_delivery_options_labels = null
        }
      }
    }
  }
</script>
<style>
  span.el-select__tags-text {
    color: #fff;
  }
  .el-select {
    width: 100%;
  }
  .selectMethod {
    width: 100%;
  }
  .section-header {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    border-bottom: 1px solid #ececf3;
  }
  .section-header__icon {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
  .section-header__title {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: #2c2c2c;
  }
  .reward-card__help {
    font-size: 13px;
    color: #9a9a9a;
    margin: 0 0 14px;
  }
  .reward-card__control {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .reward-card__control span {
    font-size: 15px;
    white-space: nowrap;
  }
  .reward-card__control input.form-control {
    flex: 0 0 auto;
    width: 110px;
    margin: 0 10px;
  }
  .translations-card .translations-title {
    margin: 0 0 15px 0;
    font-size: 14px;
    font-weight: 600;
    color: #66615b;
  }
  .translations-card .lang-tabs {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 2px;
    margin-bottom: 18px;
    border-bottom: 1px solid #e3e3e3;
  }
  .translations-card .lang-tab {
    cursor: pointer;
    padding: 6px 14px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: #9a9a9a;
    background: transparent;
    border: none;
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;
    transition: color .15s ease, border-color .15s ease;
    user-select: none;
  }
  .translations-card .lang-tab:hover {
    color: #674BD2;
  }
  .translations-card .lang-tab.active {
    color: #674BD2;
    border-bottom-color: #674BD2;
  }
  .translations-card .lang-tab.errorT {
    color: #ef8157;
  }
  .translations-card .lang-tab.errorT.active {
    border-bottom-color: #ef8157;
  }
  .translations-card .form-group {
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/TopCategories/TopCategoryForm.vue